<template>
  <div class="rounded-[12px] inline-flex justify-start items-center h-10">
    <label class="flex justify-between items-center flex-row my-2 select-none cursor-pointer w-full">
      <div class="mr-4 text-sm font-bold">Без залога</div>
      <RmToggleButton
        :value="withoutDeposit"
        :sync="true"
        color="#34C759"
        @change="handleChangeToggleButton"
      />
    </label>
  </div>
</template>

<script>
import RmToggleButton from '~/components/shared/rm_toggle_button.vue'
export default {
  components: {
    RmToggleButton,
  },
  setup () {
    const search = useSearch()
    const searchForm = useSearchForm()
    return {
      searchForm,
      withoutDeposit: searchForm.withoutDeposit,
      getFilterByKind: search.getFilterByKind,
      changeParams: searchForm.changeParams,
    }
  },
  methods: {
    handleChangeToggleButton ({ value }) {
      this.searchForm.setIsChangedParams(true)
      this.searchForm.setChangedFilter({
        action: value,
        id: this.getFilterByKind('NO_DEPOSIT').filter.id,
        name: 'Без залога',
        type: 'SWITCH',
      })

      if (value) {
        this.changeParams({ key: 'page', value: null })
        this.changeParams({ key: 'without_deposit', value: 1 })
      } else {
        this.changeParams({ key: 'page', value: null })
        this.changeParams({ key: 'without_deposit' })
      }
    },
  },
}
</script>
